import router from '../router/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false,speed: 500 })

router.beforeEach((to, from, next) => {
    console.log('1')
    NProgress.start()
    next()
})

router.afterEach(() => {
    console.log('2')
    NProgress.done()
})


